@if (item) {
  <div class="card bg-white dashboard-stats-cards daily-report-card pt-4 pl-3 p-3 pb-3">
    <!-- <div class="card-header dashboard-stats-card-header">
    <div class="card-header-text text-white font-weight-bold">
      {{ item.heading |translate | async}}
    </div>
    <div class="card-header-icon position-absolute">
      <i class="fa fa-refresh text-white pr-2" (click)="loadAllData()" aria-hidden="true"></i>
      <i class="fa fa-info-circle text-white" aria-hidden="true"></i>
    </div>
    <div class="card-header-icon position-absolute">
      <i class="fa fa-info-circle text-white" aria-hidden="true"></i>
    </div>
  </div> -->
  <h5>{{ item.heading |translate | async}}</h5>
  <div class="card-body p-0">
    @if (chartData && chartLabels && chartOptions && chartColours) {
      <div class="card-map-container">
        <div class="chart-wrapper mt-3 mx-3" style="height:70px;">
          <canvas baseChart class="chart" [datasets]="chartData" [labels]="chartLabels" [options]="chartOptions" [colors]="chartColours" [legend]="chartLegend" [chartType]="chartType"></canvas>
        </div>
      </div>
    }
    <div class="card-stats-container">
      <div class="d-flex">
        <div class="flex-fill">
          <img src="assets/images/donut.png">
        </div>
        <div class="p-2 flex-fill">
          <div class="">
            <div class="daily-reprt-card-stext"><i class="fa fa-circle status-1" aria-hidden="true"></i><span class="pl-2">Pending</span></div>
            <div class="daily-reprt-card-stext"><i class="fa fa-circle status-2" aria-hidden="true"></i><span class="pl-2">Walkin</span></div>
            <div class="daily-reprt-card-stext"><i class="fa fa-circle status-3" aria-hidden="true"></i><span class="pl-2">Referral</span></div>
            <div class="daily-reprt-card-stext"><i class="fa fa-circle status-4" aria-hidden="true"></i><span class="pl-2">Cancelled</span></div>
          </div>
        </div>
      </div>
      <!-- <div class="card-stats-wrapper">
      <div class="spinner-border text-info" *ngIf="isLoading"></div>
      <div class="card-stats-number" (click)="showLinkedWidget('current_count_datasource')" data-toggle="tooltip" data-placement="top" title="{{ item.current_count_datasource.prefix_str |translate | async}} " *ngIf="_Count['current_count_datasource'] != undefined">{{ _Count['current_count_datasource'] }}
      </div>
      <div class="card-stats-text" (click)="showLinkedWidget('past_count_datasource')" *ngIf="_Count['past_count_datasource'] != undefined">{{ _Count['past_count_datasource'] }}
        <small *ngIf="item.past_count_datasource.prefix_str != undefined"> {{ item.past_count_datasource.prefix_str |translate | async}} </small>
      </div>
    </div> -->
    <!-- <div class="card-action-wrapper text-center">
    <i class="fa fa-arrow-circle-o-right card-action-icon" aria-hidden="true"></i>
  </div> -->
</div>
</div>
</div>
}